import Vue from "vue";
import VueRouter from "vue-router";
import Index from "./components/index/index";
import Lcfw from "./components/index/lcfw";
import Xwzx from "./components/index/xwzx";
import XwDetail from "./components/index/xwDetail";
import Khal from "./components/index/khal";
import KhalDetail from "./components/index/khalDetail";
import WhzlDetail from "./components/index/whzlDetail";
import MnclDetail from "./components/index/mnclDetail";
import XjxjDetail from "./components/index/xjxjDetail";
import MsnyDetail from "./components/index/msnyDetail";
import Cpzx from "./components/index/cpzx";
import Lianxi from "./components/index/lianxi";
import Contact from "./components/index/contact";
import Gywm from "./components/index/gywm";

Vue.use(VueRouter);

const routes = [
	{ path: "", redirect: "/index" },
	{ path: "/index", component: Index,meta:{name:'1'}},
	{ path: "/lcfw", component: Lcfw,meta:{name:'4'} },
	{ path: "/xwzx", component: Xwzx ,meta:{name:'6'}},
	{ path: "/xwDetail", component: XwDetail },
	{ path: "/khal", component: Khal,meta:{name:'5'} },
	{ path: "/khalDetail", component: KhalDetail},
	{ path: "/whzlDetail", component: WhzlDetail},
	{ path: "/mnclDetail", component: MnclDetail},
	{ path: "/xjxjDetail", component: XjxjDetail},
	{ path: "/msnyDetail", component: MsnyDetail},
	{ path: "/contact", component: Contact},
	{ path: "/cpzx", component: Cpzx ,meta:{name:'2'}},
	{ path: "/lianxi", component: Lianxi,meta:{name:'7'} },
	{ path: "/gywm", component: Gywm ,meta:{name:'3'}},
];

export default new VueRouter({ routes });
